import axios from "axios";
import { API_URL, RESPONSE_CODE } from "@/general/config/constants";
import ENV from "@/general/mixins/const/custom/env";
import LocalStorage from "@/general/utils/storage";
import loginInfo from "../store/modules/loginInfo";
const DEBUG = process.env.NODE_ENV === ENV.DEVELOPMENT;

const http = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

http.interceptors.response.use(
  async (response) => {
    if (DEBUG) {
      //console.log('%c<<<<<<<<<<<< Axios['+response.config.method+'] '+response.config.url, 'color:#6c03ca; font-weight: bold');
      //console.log(response);
    }
    if (
      response.request?.responseType === "blob" &&
      response.headers &&
      response.headers["x-suggested-filename"]
    ) {
      return {
        data: response.data,
        filename: response.headers["x-suggested-filename"]
      };
    } else {
      return response.data;
    }
  },
  async (error) => {
    const ssoFlg = loginInfo.isSso;
    console.log({ error });

    if (error.response) {
      if (
        error.response.status === RESPONSE_CODE.UNAUTHORIZED &&
        error.response.config.url != "/session-time-out/" &&
        error.response.config.url != "/v1/ssocheck/IC/"
      ) {
        LocalStorage.removeAll();
        if (ssoFlg) {
          // SSOログイン時は行き止まり画面へ遷移する
          window.location.href = "/session-time-out/";
        } else {
          if (
            error.response.config.url === "/v1/ic-session/get" ||
            document.cookie.indexOf(
              process.env.VUE_APP_SESSION_COOKIE_NAME + "="
            ) === -1
          ) {
            window.location.href =
              process.env.VUE_APP_AUTH_FACADE +
              "?callback_authorization_start_uri=" +
              process.env.VUE_APP_API_DOMAIN +
              "/v1/top/auth-start";
          } else {
            window.location.href = "/session-time-out/";
          }

        }
      }
      try {
        // 認可対応 認可のプロパティが返ってきて、認可がfalseの場合はNG.リダイレクトする
        if (
          error.response.status === RESPONSE_CODE.FORBIDDEN &&
          error.response.config.url == "/v1/ic-session/get"
        ) {
          if (ssoFlg) {
            // SSOログイン時は行き止まり画面へ遷移する
            window.location.href = "/session-time-out/";
          } else {
            const authError = process.env.VUE_APP_IC_DOMAIN + "/not-available/";
            window.location.href = authError;
          }
        }
      } catch (e) {
        // nothing to do
        console.log(e);
      }
      return {
        ...error.response,
        isError: true
      };
    } else {
      return false;
    }
  }
);

export { http };
